exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg)}}@keyframes spin{100%{transform:rotate(360deg)}}#root{margin:0;min-height:100%}#root{display:flex;flex-direction:column}.app-wrapper{flex-grow:1}header,footer{flex:0 0 auto}nav{flex:0 0 auto}main{display:flex;flex:1;flex-direction:column;height:100%;overflow:visible}.page{flex:1 0 auto}.page:empty{display:none}@media (max-width: 992px){.why-collect-data-panel{margin-top:3.2rem}}.cmp-paper-plane{fill:none;stroke:#22c69d;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}.email-address{font-weight:bold}.activation-panel_footer{color:#8b7f97;font-size:1.4rem;line-height:1.6rem}.generic-error-message-panel,.forgot-password-panel{text-align:left}.page-wrapper{min-height:calc(100vh - 6.8rem)}\n", ""]);

// exports
exports.locals = {
	"enginuity-azurite-blue": "#3c3aff",
	"enginuity-celestial-blue": "#170030",
	"enginuity-malachite-green": "#22c69d",
	"enginuity-silica-sand": "#dcbd96",
	"enginuity-white-transparent": "rgba(255,255,255,0.4)",
	"enginuity-transparent": "transparent",
	"enginuity-celestial-blue-25": "#c5bfcb",
	"enginuity-celestial-blue-50": "#8b7f97",
	"enginuity-celestial-blue-10": "#e7e5ea",
	"enginuity-celestial-blue-5": "#f3f2f4",
	"enginuity-celestial-blue-2": "#fafafb",
	"enginuity-double-spanish": "#ead8c0",
	"enginuity-merino": "#f6efe5",
	"enginuity-white": "#fff",
	"enginuity-black": "#000",
	"enginuity-grey": "#8e8e8e",
	"enginuity-error-red": "#d66450",
	"enginuity-light-grey": "#e7e5ea",
	"enginuity-charcoal": "#414042",
	"enginuity-base-grey": "#fafafb",
	"enginuity-base-border": "#f3f2f4",
	"enginuity-purple-grey": "#8b7f97",
	"enginuity-purple-grey-light": "#c5bfcb",
	"enginuity-colour-font": "#170030",
	"enginuity-colour-accent": "#170030",
	"enginuity-malibu": "#5ac8fa",
	"enginuity-supernova": "#fc0",
	"enginuity-pizazz": "#ff9500",
	"enginuity-valencia": "#d63d29",
	"enginuity-white-smoke": "#efefef",
	"social-facebook": "#39619f",
	"social-twitter": "#55acee",
	"social-snap": "#fffc00",
	"social-insta": "#517fa4",
	"social-google": "#f33f2c",
	"social-youtube": "#b00",
	"social-git": "#333"
};